export const GeneralSecurityConceptsQuestions = [
    {
        id: 'sec-gen-001',
        text: "What search string should be used in a company's web filter to block access to non-encrypted websites?",
        options: [
            'ftp://',
            'http://',
            'https://',
            'sftp://'
        ],
        correctAnswer: 1,
        domain: 'Security Operations',
        difficulty: 0.2,
    },
    {
        id: 'sec-gen-002',
        text: 'Which security framework would be most appropriate for an organization primarily focused on protecting credit card transactions?',
        options: [
            'ISO 27001',
            'PCI DSS',
            'NIST Cybersecurity Framework',
            'GDPR'
        ],
        correctAnswer: 1,
        domain: 'General Security Concepts',
        difficulty: 0.3,
        explanation: 'The PCI DSS focuses solely on securing cardholder data. GDPR is an EU regulation protecting the personal data of any individual within the EU. ISO 27001 is an international standard for managing an Information Security Management System (ISMS), whereas NIST CSF is a US-based framework for managing cybersecurity risk.'
    },
    {
        id: 'sec-gen-003',
        text: 'A software developer is distributing application files through their website. What should the developer provide on the website to enable users to verify the integrity of their downloaded files?',
        options: [
            'License keys',
            'Hashes',
            'Serial numbers',
            'Digital certificates'
        ],
        correctAnswer: 1,
        domain: 'Security Development',
        difficulty: 0.8,
        explanation: 'License keys allow users to access the software, while hashes verify the integrity of the downloaded files. Digital certificates provide a digital signature for authenticating users and applications.',
    },
    {
        id: 'sec-gen-004',
        text: 'Which security framework is specifically designed for protecting payment card data?',
        options: [
            'NIST CSF',
            'ISO 27001',
            'GDPR',
            'PCI DSS'
        ],
        correctAnswer: 3,
        domain: 'General Security Concepts',
        difficulty: 0.3,
        explanation: "PCI DSS focuses solely on securing cardholder data. GDPR is an EU regulation protecting the personal data of any individual within the EU. ISO 27001 is an international standard for managing an Information Security Management System (ISMS), whereas NIST CSF is a US-based framework for managing cybersecurity risk."
    },
    {
        id: 'sec-gen-005',
        text: 'Which authentication factor would be considered "something you have"?',
        options: [
            'PIN number',
            'Password',
            'Hardware token',
            'Fingerprint'
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.3,
        explanation: "PIN numbers and passwords are something you know. A fingerprint is something you are. Hardware tokens require you to have a physical (hardware device), thus being considered something you have."
    },
    {
        id: 'sec-gen-006',
        text: 'What is the primary benefit of homomorphic encryption?',
        options: [
            'Stronger key generation',
            'Faster encryption speed',
            'Smaller encrypted file size',
            'Allows computation on encrypted data'
        ],
        correctAnswer: 3,
        domain: 'General Security Concepts',
        difficulty: 0.8,
        explanation: 'Homomorphic encryption allows computations to be performed directly on encrypted data without needing to decrypt it first, preserving privacy while enabling processing.'
    },
    {
        id: 'sec-gen-007',
        text: 'When is tokenization most appropriate to use?',
        options: [
            'Managing user sessions',
            'Protecting payment card data',
            'Securing network traffic',
            'Encrypting files'
        ],
        correctAnswer: 1,
        domain: 'General Security Concepts',
        difficulty: 0.6,
        explanation: 'Tokenization replaces sensitive data (like credit card numbers) with non-sensitive tokens that maintain the same format. It is most commonly used for protecting payment card data in PCI DSS compliant environments.'
    },
    {
        id: 'gen-sec-008',
        text: 'Which hashing algorithm is commonly used in digital signatures and provides a 256-bit output?',
        options: [
            'MD5',
            'SHA-1',
            'RIPEMD-160',
            'SHA-256'
        ],
        correctAnswer: 3,
        domain: 'General Security Concepts',
        difficulty: 0.4,
        explanation: 'SHA-256 (Secure Hash Algorithm 256-bit) is part of the SHA-2 family and produces a 256-bit hash output. It is widely used in digital signatures, certificate generation, and blockchain technology due to its strong collision resistance.'
    },
    {
        id: 'gen-sec-009',
        text: 'What is the primary purpose of a demilitarized zone (DMZ)?',
        options: [
            'To isolate internal networks from external threats',
            'To provide high-speed connectivity between internal networks',
            'To improve network performance',
            'To segment internal networks for better security'
        ],
        correctAnswer: 0,
        domain: 'Security Architecture',
        difficulty: 0.5,
        explanation: "A DMZ acts as a buffer zone between the public internet and an organization's internal network."
    },
    {
        id: 'gen-sec-010',
        text: 'Which security principle allows for the attribution of messages to specific individuals?',
        options: [
            'Authentication',
            'Authorization',
            'Non-repudiation',
            'Accountability'
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.5,
        explanation: 'Non-repudiation ensures that a sender cannot deny sending a message, providing definitive attribution of actions to individuals.'
    },
    {
        id: 'gen-sec-011',
        text: 'What is the primary factor to consider while developing a web application for reporting health emergencies in a healthcare organization?',
        options: [
            'Integrity',
            'Authentication',
            'Confidentiality',
            'Availability'
        ],
        correctAnswer: 3,
        domain: 'General Security Concepts',
        difficulty: 0.2,
        explanation: 'For emergency reporting systems, availability is crucial as the system must be accessible when needed to report health emergencies.'
    },
    {
        id: 'gen-sec-012',
        text: 'What technique is used to add complexity before applying a one-way data transformation algorithm?',
        options: [
            'Encryption',
            'Masking',
            'Salting',
            'Hashing'
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.6,
        explanation: 'Salting adds random data to input before hashing, making rainbow table attacks more difficult.'
    },
    {
        id: 'gen-sec-013',
        text: 'What technique involves hiding code or text within a graphical image?',
        options: [
            'Watermarking',
            'Encryption',
            'Steganography',
            'Obfuscation'
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.2,
        explanation: 'Steganography is the practice of concealing messages or data within other non-secret data or carriers, such as images.'
    },
    {
        id: 'gen-sec-014',
        text: 'Which authentication protocol is commonly used for single sign-on (SSO) in web applications and relies on XML-based messages?',
        options: [
            'SAML',
            'RADIUS',
            'EAP',
            'Kerberos'
        ],
        correctAnswer: 0,
        domain: 'General Security Concepts',
        difficulty: 0.6,
        explanation: 'SAML (Security Assertion Markup Language) is an XML-based framework for exchanging authentication and authorization data between security domains. It is widely used for SSO in web applications.'
    },
    {
        id: 'gen-sec-015',
        text: 'What is the primary function of RADIUS?',
        options: [
            'Web-based single sign-on',
            'Centralized authentication, authorization, and accounting (AAA) for network access',
            'Secure email transmission',
            'Database encryption'
        ],
        correctAnswer: 1,
        domain: 'General Security Concepts',
        difficulty: 0.3,
        explanation: 'RADIUS (Remote Authentication Dial-In User Service) provides centralized AAA management for users who connect and use a network service.'
    },
    {
        id: 'gen-sec-016',
        text: 'Which of the following protocols is commonly used for network access control, particularly in wireless environments, and often works in conjunction with RADIUS?',
        options: [
            'LDAP',
            'SAML',
            'EAP',
            'IPsec'
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.6,
        explanation: 'EAP (Extensible Authentication Protocol) is a framework for *network* authentication authentication methods. It is frequently used with RADIUS for wireless network access control.'
    },
    {
        id: 'gen-sec-017',
        text: 'Which protocol utilizes tokens for authentication and is often used in conjunction with OAuth 2.0?',
        options: [
            'RADIUS',
            'Kerberos',
            'OpenID Connect',
            'CHAP'
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.8,
        explanation: 'OpenID Connect (OIDC) is an authentication layer on top of OAuth 2.0. It uses JSON Web Tokens (JWTs) to verify user identity.'
    },
    {
        id: 'gen-sec-018',
        text: 'Which of the following best describes the core difference between SAML and OpenID Connect?',
        options: [
            'SAML is primarily for web-based SSO, while OpenID Connect is focused on API authorization.',
            'SAML uses XML, while OpenID Connect uses JSON.',
            'SAML is an authentication protocol, while OpenID Connect is an authorization framework.',
            'SAML is for internal networks, while OpenID Connect is for external networks.'
        ],
        correctAnswer: 1,
        domain: 'General Security Concepts',
        difficulty: 0.8,
        explanation: 'A key difference is the data format: SAML uses XML, while OpenID Connect uses JSON. While SAML is widely used for web SSO; OpenID offers advantages in modern web and mobile contexts due to its use of JSON.'
    },
    {
        id: 'gen-sec-019',
        text: 'In a wireless network using WPA2-Enterprise, which protocol is commonly used for authentication with a RADIUS server?',
        options: [
            'IPSec',
            'CHAP',
            'EAP',
            'PAP'
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.6,
        explanation: 'EAP (Extensible Authentication Protocol) is the standard authentication framework used with WPA2-Enterprise and often communicates with a back-end RADIUS server for authentication.'
    },
    {
        id: 'gen-sec-020',
        text: 'Which of the following is NOT a typical use case for RADIUS?',
        options: [
            'Website Single Sign-On',
            'VPN Authentication',
            'Wireless Network Access',
            'Network Device Administration'
        ],
        correctAnswer: 0,
        domain: 'General Security Concepts',
        difficulty: 0.2,
        explanation: 'RADIUS is primarily used for network access authentication, not web-based single sign-on. SAML or OpenID Connect are more suitable for SSO.'
    },
    {
        id: 'gen-sec-021',
        text: 'Which protocol is most suitable for authenticating users to a network using existing Active Directory credentials?',
        options: [
            'SAML',
            'RADIUS with EAP-TLS',
            'OpenID Connect',
            'OAuth 2.0'
        ],
        correctAnswer: 1,
        domain: 'General Security Concepts',
        difficulty: 0.7,
        explanation: 'RADIUS with EAP-TLS is commonly used to integrate with Active Directory, allowing users to authenticate with their domain credentials for network access.'
    },
    {
        id: 'gen-sec-022',
        text: 'Which protocol commonly uses JSON Web Tokens (JWTs) for transmitting user information?',
        options: [
            'RADIUS',
            'SAML',
            'OpenID Connect',
            'Kerberos'
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.9,
        explanation: 'OpenID Connect (OIDC) uses JSON Web Tokens (JWTs) to carry claims about the authenticated user between the identity provider and the relying party.'
    },
    {
        id: 'gen-sec-023',
        text: 'In the context of identity and access management (IAM), what is the role of an Identity Provider (IdP)?',
        options: [
            'To manage network infrastructure components.',
            'To enforce network security policies.',
            'To monitor system performance and availability.',
            'To store and verify user credentials, providing authentication services.',
        ],
        correctAnswer: 3,
        domain: 'General Security Concepts',
        difficulty: 0.1,
        explanation: 'An Identity Provider (IdP) is responsible for managing user identities and providing authentication services. It verifies user credentials and issues security tokens or assertions that can be used by Service Providers (SPs) for authorization.'
    },
    {
        id: 'gen-sec-024',
        text: 'A cryptographic hash function is primarily used to ensure:',
        options: [
            'Data confidentiality',
            'Data integrity',
            'User authentication',
            'Secure communication'
        ],
        correctAnswer: 1,
        domain: 'General Security Concepts',
        difficulty: 0.1,
        explanation: 'Hash functions create a fixed-size output (hash) from an input of any size. This hash is used to verify that data has not been altered.'
    },
    {
        id: 'gen-sec-025',
        text: "Which authentication method relies on something you have, something you know, and something you are?",
        options: [
            "Single-factor authentication",
            "Two-factor authentication",
            "Multi-factor authentication",
            "Kerberos"
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.0,
        explanation: "Multi-factor authentication uses multiple independent credentials, such as a token (something you have), a password (something you know), and biometrics (something you are)."
    },
    {
        id: 'net-con-026',
        text: "What is the primary function of DHCP (Dynamic Host Configuration Protocol)?",
        options: [
            "To resolve domain names to IP addresses.",
            "To automatically assign IP addresses and other network configuration parameters to devices.",
            "To route network traffic between different networks.",
            "To provide secure communication over a network."
        ],
        correctAnswer: 1,
        domain: 'Networking Concepts',
        difficulty: 0.3,
        explanation: "DHCP automates IP address assignment, subnet masks, default gateways, and DNS server addresses. DNS resolves domain names. Routers handle network routing. TLS/SSL provides secure communication."
    },
    {
        id: 'net-con-027',
        text: "What information is typically provided by a DHCP server to a client?",
        options: [
            "MAC address, manufacturer, and device type.",
            "IP address, subnet mask, default gateway, and DNS server addresses.",
            "Firewall rules, intrusion detection signatures, and antivirus definitions.",
            "Usernames, passwords, and access control lists."
        ],
        correctAnswer: 1,
        domain: 'Networking Concepts',
        difficulty: 0.1,
        explanation: "DHCP provides essential network configuration parameters. MAC addresses are hardware identifiers. Security configurations are managed separately. User credentials are handled by authentication systems."
    },
    {
        id: 'gen-sec-028',
        text: "What concept ensures that data remains unaltered and trustworthy throughout its lifecycle?",
        options: [
            "Availability",
            "Integrity",
            "Non-repudiation",
            "Authentication"
        ],
        correctAnswer: 1,
        domain: 'General Security Concepts',
        difficulty: 0.1,
        explanation: "Integrity focuses on maintaining the accuracy and consistency of data, preventing unauthorized modification or corruption. Availability ensures timely and reliable access to data. Non-repudiation prevents an entity from denying a previous action or commitment. Authentication verifies the identity of a user or device."
    },
    {
        id: 'gen-sec-029',
        text: "An organization is implementing a new data storage solution. They prioritize ensuring that data can be recovered quickly in the event of a system failure, even if some data loss is tolerable. Which of the following principles of the CIA triad is being emphasized the MOST, and which related concept is being implicitly de-emphasized?",
        options: [
            "Confidentiality is emphasized; Integrity is de-emphasized.",
            "Integrity is emphasized; Availability is de-emphasized.",
            "Availability is emphasized; Integrity is de-emphasized.",
            "Confidentiality is emphasized; Availability is de-emphasized."
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.8,
        explanation: "Prioritizing quick recovery with some data loss means Availability is paramount. The acceptance of data loss directly implies a de-emphasis on absolute Integrity. Confidentiality is about secrecy, which isn't the core issue here."
    },
    {
        id: 'gen-sec-030',
        text: 'A retail chain\'s cybersecurity team discovers plaintext credentials in network traffic during a security audit of their point-of-sale systems. This indicates what fundamental security issue?',
        options: [
            'Inadequate network segmentation',
            'Missing security patches',
            'Use of legacy protocols',
            'Improper certificate management'
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.6,
        explanation: 'Finding plaintext credentials in network traffic typically indicates the use of legacy or insecure protocols (like telnet, FTP, or HTTP) instead of their encrypted counterparts (SSH, SFTP, HTTPS). Modern secure protocols encrypt credentials and other sensitive data in transit.'
    },
    {
        id: 'gen-sec-031',
        text: 'A healthcare startup is collecting patient data for their new telemedicine platform. Under GDPR compliance, how would these patients be classified?',
        options: [
            'Data processors',
            'Data controllers',
            'Data custodians',
            'Data subjects',
        ],
        correctAnswer: 3,
        domain: 'General Security Concepts',
        difficulty: 0.0,
        explanation: 'In data privacy frameworks like GDPR, individuals whose personal data is being collected and processed are classified as data subjects. This is distinct from data controllers (who determine how data is processed) and processors (who process data on behalf of controllers).'
    },
    {
        id: 'gen-sec-032',
        text: 'A retail chain\'s cybersecurity team discovers plaintext credentials in network traffic during a security audit of their point-of-sale systems. This indicates what fundamental security issue?',
        options: [
            'Inadequate network segmentation',
            'Missing security patches',
            'Improper certificate management',
            'Use of legacy protocols'
        ],
        correctAnswer: 3,
        domain: 'General Security Concepts',
        difficulty: 0.6,
        explanation: 'Finding plaintext credentials in network traffic typically indicates the use of legacy or insecure protocols (like telnet, FTP, or HTTP) instead of their encrypted counterparts (SSH, SFTP, HTTPS). Modern secure protocols encrypt credentials and other sensitive data in transit.'
    },
    {
        id: 'gen-sec-033',
        text: 'A healthcare startup is collecting patient data for their new telemedicine platform. Under GDPR compliance, how would these patients be classified?',
        options: [
            'Data subjects',
            'Data processors',
            'Data controllers',
            'Data custodians'
        ],
        correctAnswer: 0,
        domain: 'General Security Concepts',
        difficulty: 0.0,
        explanation: 'In data privacy frameworks like GDPR, individuals whose personal data is being collected and processed are classified as data subjects. This is distinct from data controllers (who determine how data is processed) and processors (who process data on behalf of controllers).'
    },
    {
        id: 'gen-sec-034',
        text: 'Review the authentication configuration:\nLogin requires:\n- 6-digit PIN\n- Facial recognition scan\nWhat factors are being used?',
        options: [
            'Something you know and something you are',
            'Something you have and something you know',
            'Something you are and something you have',
            'Something you know and somewhere you are'
        ],
        correctAnswer: 0,
        domain: 'General Security Concepts',
        difficulty: 0.4,
        explanation: 'A PIN is something you know (knowledge factor) while facial recognition is something you are (biometric factor). This represents basic multi-factor authentication using two different factor types.'
    },
    {
        id: 'gen-sec-035',
        text: 'Your team discovers these server configurations:\n- Default admin passwords\n- Unnecessary services running\n- Unpatched vulnerabilities\nWhat single action addresses all these issues?',
        options: [
            'Patch management',
            'Server hardening',
            'Access control implementation',
            'Configuration management'
        ],
        correctAnswer: 1,
        domain: 'General Security Concepts',
        difficulty: 0.7,
        explanation: 'Server hardening is the comprehensive process of securing a server by removing unnecessary services, updating default configurations, and applying security patches - addressing all the identified issues.'
    },
    {
        id: 'gen-sec-036',
        text: 'In configuring authentication for your enterprise app, users must provide their password and plug in their YubiKey. Which authentication principle is being implemented?',
        options: [
            'Something you know and something you have',
            'Something you are and something you know',
            'Something you have and something you are',
            'Something you know and somewhere you are'
        ],
        correctAnswer: 0,
        domain: 'General Security Concepts',
        difficulty: 0.0,
        explanation: 'This implements two-factor authentication using a password (something you know) and a YubiKey (something you have). These two different factor types provide stronger security than single-factor authentication.'
    },
    {
        id: 'gen-sec-037',
        text: 'Your organization needs centralized authentication for network device management instead of local accounts. Which infrastructure component provides this?',
        options: [
            'SIEM platform',
            'AAA framework',
            'VPN concentrator',
            'Load balancer'
        ],
        correctAnswer: 1,
        domain: 'General Security Concepts',
        difficulty: 0.3,
        explanation: 'AAA (Authentication, Authorization, and Accounting) frameworks provide centralized authentication management for network devices, eliminating the need for local accounts while maintaining access control and audit logging.'
    },
    {
        id: 'gen-sec-038',
        text: 'A financial technology startup is evaluating different technologies for their payment processing system. Which technology provides transaction integrity through a distributed, immutable ledger system?',
        options: [
            'Blockchain',
            'Hashing',
            'File checksums',
            'Digital signatures'
        ],
        correctAnswer: 0,
        domain: 'General Security Concepts',
        difficulty: 0.1,
        explanation: 'Blockchain technology uses a distributed public ledger system where transactions are recorded in blocks that are cryptographically linked. This creates an immutable chain of records that provides transaction integrity and transparency.'
    },
    {
        id: 'gen-sec-039',
        text: 'Which cryptographic process involves adding random characters to a password before hashing to increase entropy?',
        options: [
            'Salting',
            'Padding',
            'Stretching',
            'Concatenation'
        ],
        correctAnswer: 0,
        domain: 'General Security Concepts',
        difficulty: 0.5,
        explanation: 'Password salting involves adding a random string (salt) to a password before hashing. This prevents rainbow table attacks and ensures that identical passwords produce different hash outputs.'
    },
    {
        id: 'gen-sec-040',
        text: 'Which cryptographic operation converts plaintext passwords into fixed-length strings that cannot be reversed?',
        options: [
            'Compression',
            'Encoding',
            'Hashing',
            'Encryption'
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.5,
        explanation: 'Hashing is a one-way cryptographic function that converts input of any length into a fixed-length string of characters. Unlike encryption, hashing cannot be reversed to reveal the original input.'
    },
    {
        id: 'gen-sec-041',
        text: 'An organization implements hardware security modules across their environment. Which similar technology could also be used to capture user authentication credentials?',
        options: [
            'Network monitor',
            'Keylogger',
            'Smart card reader',
            'RADIUS server'
        ],
        correctAnswer: 1,
        domain: 'General Security Concepts',
        difficulty: 0.6,
        explanation: 'While all options relate to authentication or credentials, a keylogger specifically captures user logon information. Hardware or software keyloggers can record keystrokes to obtain credentials, unlike the other options which are legitimate authentication technologies.'
    },
    {
        id: 'gen-sec-042',
        text: 'In a high-availability server environment, which configuration allows multiple servers to share workload while appearing as a single system to users?',
        options: [
            'Load balancing',
            'Server clustering',
            'Virtual hosting',
            'Container orchestration'
        ],
        correctAnswer: 1,
        domain: 'General Security Concepts',
        difficulty: 0.7,
        explanation: 'Server clustering enables multiple servers to work together as a single system, providing both high availability and load distribution. While load balancing distributes traffic, clustering adds the complexity of shared resources and state synchronization between nodes.'
    },
    {
        id: 'gen-sec-043',
        text: 'Which primary characteristic differentiates WPS from both WPA and WEP wireless security protocols?',
        options: [
            'Uses push-button configuration instead of pre-shared keys',
            'Supports enterprise authentication servers',
            'Implements TKIP encryption',
            'Requires wireless isolation'
        ],
        correctAnswer: 0,
        domain: 'General Security Concepts',
        difficulty: 0.6,
        explanation: 'Wi-Fi Protected Setup (WPS) uniquely uses push-button or PIN configuration rather than pre-shared keys. This differs fundamentally from WPA and WEP which both rely on key-based authentication methods.'
    },
    {
        id: 'gen-sec-044',
        text: 'Which key difference distinguishes RFID from infrared communication?',
        options: [
            'Signal range capabilities',
            'Line of sight requirements',
            'Radio frequency usage',
            'Data transfer speed'
        ],
        correctAnswer: 1,
        domain: 'General Security Concepts',
        difficulty: 0.6,
        explanation: 'While both are wireless technologies, infrared requires direct line of sight between devices to communicate, whereas RFID can communicate through various materials and does not require direct line of sight.'
    },
    {
        id: 'gen-sec-045',
        text: 'Which comprehensive security control protects sensitive information during storage and transmission?',
        options: [
            'Access control',
            'Hashing algorithms',
            'Digital signatures',
            'Encryption'
        ],
        correctAnswer: 3,
        domain: 'General Security Concepts',
        difficulty: 0.6,
        explanation: 'While other controls provide specific protections, encryption uniquely protects both data at rest (stored data) and data in transit (transmitted data) by making it unreadable without the proper decryption key.'
    },
    {
        id: 'gen-sec-046',
        text: 'Which wireless security protocol uses an 8-digit numeric code for device authentication?',
        options: [
            'WPA3-Personal',
            'WPA2-Enterprise',
            'WPS',
            'EAP-TLS'
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.6,
        explanation: 'Wi-Fi Protected Setup (WPS) specifically uses an 8-digit PIN for device authentication, unlike other protocols that use passwords or certificates. This makes WPS unique but also vulnerable to brute force attacks.'
    },
    {
        id: 'gen-sec-047',
        text: 'What is the key distinction between managerial and operational controls in an information security program?',
        options: [
            'Managerial controls focus on risk decisions and policies, while operational controls handle day-to-day security tasks',
            'Managerial controls are automated, while operational controls are manual',
            'Managerial controls are technical, while operational controls are administrative',
            'Managerial controls focus on network security, while operational controls focus on physical security'
        ],
        correctAnswer: 0,
        domain: 'General Security Concepts',
        difficulty: 0.6,
        explanation: 'Managerial controls involve high-level decision making, risk management, and policy development, typically implemented by leadership. Operational controls are the day-to-day security procedures and tasks carried out by personnel to protect assets and maintain security, such as backup procedures or security awareness training.'
    },
    {
        id: 'gen-sec-048',
        text: 'Which wireless security protocol introduced in 1999 uses RC4 stream cipher and is now considered fundamentally insecure?',
        options: [
            'WEP',
            'WPA2',
            'MAC filtering',
            'WPS'
        ],
        correctAnswer: 0,
        domain: 'General Security Concepts',
        difficulty: 0.4,
        explanation: 'Wired Equivalent Privacy (WEP) was the first wireless security protocol, using RC4 stream cipher. Due to critical flaws in its implementation and weak 40-bit encryption, it was deprecated in 2004 and is considered highly vulnerable to attacks.'
    },
    {
        id: 'gen-sec-049',
        text: 'A legal document that establishes confidentiality obligations between parties sharing proprietary information is known as:',
        options: [
            'Service Level Agreement (SLA)',
            'Memorandum of Understanding (MOU)',
            'Non-Disclosure Agreement (NDA)',
            'Business Associate Agreement (BAA)'
        ],
        correctAnswer: 2,
        domain: 'General Security Concepts',
        difficulty: 0.3,
        explanation: 'An NDA is a legally binding contract that establishes a confidential relationship between parties, protecting sensitive information from being shared with third parties.'
    },
    {
        id: 'gen-sec-050',
        text: 'Which command-line tool provides information about network connections, routing tables, and protocol statistics?',
        options: [
            'Netstat',
            'Ping',
            'Traceroute',
            'Route'
        ],
        correctAnswer: 0,
        domain: 'General Security Concepts',
        difficulty: 0.3,
        explanation: 'Netstat (network statistics) is a command-line tool that displays network connections, routing tables, interface statistics, masquerade connections, and multicast memberships, useful for network troubleshooting and security monitoring.'
    },
    {
        "id": "gen-sec-051",
        "text": "Which network mapping tool is commonly used for network discovery and security auditing?",
        "options": [
            "Wireshark",
            "Tcpdump",
            "Netstat",
            "Nmap"
        ],
        "correctAnswer": 3,
        "domain": "General Security Concepts",
        "difficulty": 0.5,
        "explanation": "Nmap is the correct answer as it's designed for network discovery and security auditing. Wireshark is a packet analyzer, not a network mapper. Tcpdump captures network traffic but doesn't map networks. Netstat displays network connections and statistics, not network maps."
    },
    {
        id: 'gen-sec-052',
        text: 'Which term describes the systematic collection and analysis of publicly available data sources for intelligence gathering?',
        options: [
            'Threat Intelligence',
            'OSINT',
            'Data Mining',
            'Reconnaissance'
        ],
        correctAnswer: 1,
        domain: 'General Security Concepts',
        difficulty: 0.5,
        explanation: 'Open Source Intelligence (OSINT) involves collecting and analyzing publicly available information from various sources like social media, websites, and public records for intelligence purposes.'
    },
    {
        id: 'gen-sec-053',
        text: 'In software development estimation, what metric measures the relative complexity of a program based on its features and functions?',
        options: [
            'Function Point',
            'Code Coverage',
            'Cyclomatic Complexity',
            'Technical Debt'
        ],
        correctAnswer: 0,
        domain: 'General Security Concepts',
        difficulty: 0.8,
        explanation: 'Function Points measure software size by quantifying the functionality provided to users, considering inputs, outputs, inquiries, internal files, and external interfaces.'
    },
];
